
import React, { useEffect, useState } from "react";


import {
  submitEventParticipation,
  getApprovedEventSubmissions,
} from "../services/EventService";

import "./Event.css";

const EventPage = () => {
  // ======================================================
  // STATIC EVENTS
  // ======================================================

  const events = [
    {
      id: "earth-day",
      title: "Earth Day",
      icon: "🌍",
      color: "#2e7d32",
      date: "22 April",
      tagline:
        "Together we can protect our planet and create a greener future.",

      history:
        "Earth Day is celebrated every year on 22 April. It raises awareness about environmental protection, pollution, climate change and the importance of caring for our planet.",

      purpose:
        "Earth Day encourages people, schools, communities and organizations to take action for the environment and promote sustainable living.",

      importance:
        "Protecting nature, reducing pollution, saving resources and caring for our environment are shared responsibilities.",

      internationalInfo:
        "People around the world celebrate Earth Day through tree plantation, clean-up campaigns, recycling activities, awareness programs and environmental education.",

      pakistanInfo:
        "In Pakistan, Earth Day is observed through plantation drives, cleanliness campaigns, seminars, awareness walks, school activities and environmental campaigns.",

      pakistanPlaces: [
        "Islamabad",
        "Lahore",
        "Karachi",
        "Rawalpindi",
        "Faisalabad",
        "Peshawar",
      ],

      pakistanActivities: [
        "Tree plantation campaigns",
        "Community clean-up drives",
        "Plastic reduction campaigns",
        "Environmental awareness walks",
        "School and university awareness programs",
      ],

      results: [
        {
          number: "22",
          label: "April",
          icon: "📅",
        },
        {
          number: "1970",
          label: "Earth Day Started",
          icon: "🌍",
        },
        {
          number: "190+",
          label: "Countries",
          icon: "🌎",
        },
        {
          number: "1B+",
          label: "People Engaged",
          icon: "👥",
        },
      ],

      gallery: [
        "https://images.unsplash.com/photo-1497250681960-ef046c08a56e",
        "https://images.unsplash.com/photo-1441974231531-c6227db76b6e",
        "https://images.unsplash.com/photo-1469474968028-56623f02e42e",
      ],

      activities: [
        {
          id: "earth-tree",
          title: "Plant a Tree",
          description:
            "Plant a tree in your home, school, community or another suitable area.",
          icon: "🌱",
        },
        {
          id: "earth-clean",
          title: "Clean Your Area",
          description:
            "Organize or participate in a clean-up activity in your local area.",
          icon: "🧹",
        },
        {
          id: "earth-plastic",
          title: "Reduce Plastic",
          description:
            "Avoid single-use plastic and encourage others to use reusable alternatives.",
          icon: "♻️",
        },
      ],
    },

    {
      id: "water-day",
      title: "World Water Day",
      icon: "💧",
      color: "#0288d1",
      date: "22 March",
      tagline:
        "Every drop matters. Save water today for a sustainable tomorrow.",

      history:
        "World Water Day is celebrated every year on 22 March. It focuses attention on freshwater and the importance of managing water resources responsibly.",

      purpose:
        "The purpose of World Water Day is to raise awareness about water challenges and encourage people to conserve and protect freshwater resources.",

      importance:
        "Clean and safe water is essential for people, agriculture, ecosystems and economic development. Protecting water resources is important for future generations.",

      internationalInfo:
        "Around the world, governments, organizations, schools and communities organize water conservation programs, clean-up activities and educational events.",

      pakistanInfo:
        "Pakistan faces several water-related challenges. Communities and organizations promote water conservation, clean drinking water, river protection and responsible water use.",

      pakistanPlaces: [
        "Lahore",
        "Islamabad",
        "Karachi",
        "Multan",
        "Peshawar",
        "Rawalpindi",
      ],

      pakistanActivities: [
        "Water conservation awareness campaigns",
        "Cleaning rivers and water channels",
        "Fixing water leakage",
        "Promoting responsible water usage",
        "Awareness programs about clean drinking water",
      ],

      results: [
        {
          number: "22",
          label: "March",
          icon: "📅",
        },
        {
          number: "1993",
          label: "First World Water Day",
          icon: "💧",
        },
        {
          number: "71%",
          label: "Earth Covered by Water",
          icon: "🌎",
        },
        {
          number: "2B+",
          label: "People Lack Safe Water",
          icon: "🚰",
        },
      ],

      gallery: [
        "https://images.unsplash.com/photo-1500375592092-40eb2168fd21",
        "https://images.unsplash.com/photo-1548839140-29a749e1cf4d",
        "https://images.unsplash.com/photo-1437622368342-7a3d73a34c8f",
      ],

      activities: [
        {
          id: "water-save",
          title: "Save Water",
          description:
            "Reduce unnecessary water usage at home, school or workplace.",
          icon: "💧",
        },
        {
          id: "water-clean",
          title: "Clean a Water Area",
          description:
            "Participate in cleaning a river, canal, pond or other local water area.",
          icon: "🌊",
        },
        {
          id: "water-awareness",
          title: "Spread Water Awareness",
          description:
            "Educate friends, family and your community about water conservation.",
          icon: "📢",
        },
      ],
    },

    {
      id: "animal-day",
      title: "World Animal Day",
      icon: "🐾",
      color: "#8e44ad",
      date: "4 October",
      tagline:
        "Protect animals, respect nature and give every creature a better future.",

      history:
        "World Animal Day is celebrated every year on 4 October. It promotes animal welfare and raises awareness about protecting animals.",

      purpose:
        "The purpose of World Animal Day is to promote animal welfare, responsible treatment of animals and awareness about wildlife and biodiversity.",

      importance:
        "Animals play an important role in ecosystems. Protecting animals and their habitats helps maintain biodiversity and healthy natural ecosystems.",

      internationalInfo:
        "World Animal Day is celebrated globally through animal welfare campaigns, wildlife protection programs, adoption activities and educational events.",

      pakistanInfo:
        "In Pakistan, animal welfare groups, communities, students and volunteers participate in activities such as helping stray animals, protecting wildlife and spreading awareness.",

      pakistanPlaces: [
        "Lahore",
        "Islamabad",
        "Karachi",
        "Peshawar",
        "Faisalabad",
        "Murree",
      ],

      pakistanActivities: [
        "Animal welfare awareness campaigns",
        "Helping stray animals",
        "Wildlife protection awareness",
        "Animal shelter support",
        "Responsible pet care education",
      ],

      results: [
        {
          number: "4",
          label: "October",
          icon: "📅",
        },
        {
          number: "1925",
          label: "Animal Day Movement",
          icon: "🐾",
        },
        {
          number: "1000s",
          label: "Animal Species",
          icon: "🦁",
        },
        {
          number: "1",
          label: "Shared Planet",
          icon: "🌍",
        },
      ],

      gallery: [
        "https://images.unsplash.com/photo-1450778869180-41d0601e046e",
        "https://images.unsplash.com/photo-1543466835-00a7907e9de1",
        "https://images.unsplash.com/photo-1530281700549-e82e7bf110d6",
      ],

      activities: [
        {
          id: "animal-help",
          title: "Help an Animal",
          description:
            "Provide food, water or basic help to an animal that needs care.",
          icon: "🐕",
        },
        {
          id: "animal-awareness",
          title: "Spread Animal Awareness",
          description:
            "Educate people about animal welfare and responsible treatment of animals.",
          icon: "📢",
        },
        {
          id: "animal-habitat",
          title: "Protect Animal Habitats",
          description:
            "Help keep natural areas clean and safe for animals and wildlife.",
          icon: "🌳",
        },
      ],
    },
  ];

  // ======================================================
  // STATES
  // ======================================================

  const [activeEvent, setActiveEvent] = useState(events[0]);

  const [selectedActivity, setSelectedActivity] =
    useState(null);

  const [selectedFile, setSelectedFile] =
    useState(null);

  const [description, setDescription] =
    useState("");

  const [publishedActivities, setPublishedActivities] =
    useState([]);

  const [publishedLoading, setPublishedLoading] =
    useState(true);

  const [submitting, setSubmitting] =
    useState(false);

  // ======================================================
  // GET TOKEN
  // ======================================================

  const getToken = () => {
    return (
      localStorage.getItem("token") ||
      localStorage.getItem("userToken") ||
      localStorage.getItem("authToken")
    );
  };

  // ======================================================
  // GET APPROVED ACTIVITIES
  // ======================================================

  useEffect(() => {
    const loadPublishedActivities = async () => {
      try {
        setPublishedLoading(true);

        const response =
          await getApprovedEventSubmissions();

        console.log(
          "APPROVED ACTIVITIES:",
          response
        );

        let list = [];

        if (Array.isArray(response)) {
          list = response;
        } else if (
          Array.isArray(response?.submissions)
        ) {
          list = response.submissions;
        } else if (
          Array.isArray(response?.activities)
        ) {
          list = response.activities;
        } else if (
          Array.isArray(response?.data)
        ) {
          list = response.data;
        }

        setPublishedActivities(list);
      } catch (error) {
        console.error(
          "Approved activities error:",
          error
        );

        setPublishedActivities([]);
      } finally {
        setPublishedLoading(false);
      }
    };

    loadPublishedActivities();
  }, []);

  // ======================================================
  // CHANGE EVENT
  // ======================================================

  const handleEventChange = (event) => {
    setActiveEvent(event);

    setSelectedActivity(null);
    setSelectedFile(null);
    setDescription("");

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // ======================================================
  // JOIN ACTIVITY
  // ======================================================

  const handleJoinActivity = (activity) => {
    if (!getToken()) {
      alert(
        "Please login first to join this activity."
      );
      return;
    }

    setSelectedActivity(activity);
    setSelectedFile(null);
    setDescription("");

    setTimeout(() => {
      document
        .getElementById(
          "participation-section"
        )
        ?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
    }, 100);
  };

  // ======================================================
  // FILE CHANGE
  // ======================================================

  const handleFileChange = (event) => {
    const file =
      event.target.files?.[0];

    if (!file) {
      return;
    }

    const maxSize =
      20 * 1024 * 1024;

    if (file.size > maxSize) {
      alert(
        "File size must be less than 20MB."
      );

      event.target.value = "";
      setSelectedFile(null);

      return;
    }

    const allowedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/webp",
      "video/mp4",
      "video/webm",
      "video/quicktime",
    ];

    if (
      file.type &&
      !allowedTypes.includes(file.type)
    ) {
      alert(
        "Please upload JPG, PNG, WEBP image or MP4/WebM/MOV video."
      );

      event.target.value = "";
      setSelectedFile(null);

      return;
    }

    setSelectedFile(file);
  };

  // ======================================================
  // SUBMIT ACTIVITY
  // ======================================================

  const handleSubmit = async () => {
    const token = getToken();

    if (!token) {
      alert(
        "Please login first to submit your activity."
      );
      return;
    }

    if (!selectedActivity) {
      alert(
        "Please select an activity first."
      );
      return;
    }

    if (!selectedFile) {
      alert(
        "Please upload a photo or video as proof."
      );
      return;
    }

    if (!description.trim()) {
      alert(
        "Please describe your activity."
      );
      return;
    }

    try {
      setSubmitting(true);

      const formData = new FormData();

      formData.append(
        "event",
        activeEvent.id
      );

      formData.append(
        "activity",
        selectedActivity.id
      );

      formData.append(
        "activityTitle",
        selectedActivity.title
      );

      formData.append(
        "description",
        description.trim()
      );

      formData.append(
        "proof",
        selectedFile
      );

      console.log(
        "Submitting activity..."
      );

      const response =
        await submitEventParticipation(
          formData
        );

      console.log(
        "Submission response:",
        response
      );

      alert(
        "Activity submitted successfully! Admin will review your submission."
      );

      setSelectedActivity(null);
      setSelectedFile(null);
      setDescription("");

      const fileInput =
        document.getElementById(
          "event-upload"
        );

      if (fileInput) {
        fileInput.value = "";
      }
    } catch (error) {
      console.error(
        "Submission error:",
        error
      );

      alert(
        error?.message ||
          error?.error ||
          "Unable to submit activity."
      );
    } finally {
      setSubmitting(false);
    }
  };

  // ======================================================
  // GET SUBMISSION EVENT ID
  // ======================================================

  const getSubmissionEventId = (
    submission
  ) => {
    if (!submission) {
      return null;
    }

    if (
      typeof submission.event ===
      "string"
    ) {
      return submission.event;
    }

    return (
      submission.event?._id ||
      submission.event?.id ||
      null
    );
  };

  // ======================================================
  // CURRENT EVENT ACTIVITIES
  // ======================================================

  const currentPublishedActivities =
    publishedActivities.filter(
      (submission) => {
        const eventId =
          getSubmissionEventId(
            submission
          );

        /*
          Static events have IDs like:
          earth-day
          water-day
          animal-day

          Backend normally returns MongoDB
          ObjectId after submission.

          If backend event doesn't match the
          static ID, we still show the approved
          activities instead of hiding them.
        */

        if (!eventId) {
          return true;
        }

        return true;
      }
    );

  // ======================================================
  // PROOF URL
  // ======================================================

  const getProofUrl = (proof) => {
    if (!proof) {
      return "";
    }

    let value = "";

    if (typeof proof === "string") {
      value = proof;
    } else if (
      typeof proof === "object"
    ) {
      value =
        proof.url ||
        proof.path ||
        proof.secure_url ||
        proof.location ||
        proof.filename ||
        "";
    }

    if (!value) {
      return "";
    }

    if (
      value.startsWith("http://") ||
      value.startsWith("https://")
    ) {
      return value;
    }

    if (value.startsWith("/")) {
      return `${value}`;
    }

    return `/${value}`;
  };

  // ======================================================
  // CHECK VIDEO
  // ======================================================

  const isVideoFile = (url) => {
    if (!url) {
      return false;
    }

    const cleanUrl =
      url
        .split("?")[0]
        .toLowerCase();

    return (
      cleanUrl.endsWith(".mp4") ||
      cleanUrl.endsWith(".webm") ||
      cleanUrl.endsWith(".mov") ||
      cleanUrl.endsWith(".m4v")
    );
  };

  // ======================================================
  // MAIN UI
  // ======================================================

  return (
   

      <div className="event-page">

        <div className="event-dashboard">

          {/* ==================================================
              SIDEBAR
          ================================================== */}

          <aside className="event-sidebar">

            <div className="sidebar-heading">

              <span className="sidebar-logo">
                🌍
              </span>

              <div>
                <h2>
                  EcoVibe Events
                </h2>

                <p>
                  Environmental Awareness
                </p>
              </div>

            </div>

            <div className="event-menu">

              <p className="menu-title">
                AVAILABLE EVENTS
              </p>

              {events.map(
                (event) => (
                  <button
                    key={event.id}
                    type="button"
                    onClick={() =>
                      handleEventChange(
                        event
                      )
                    }
                    className={
                      activeEvent.id ===
                      event.id
                        ? "event-menu-item active"
                        : "event-menu-item"
                    }
                    style={{
                      "--event-color":
                        event.color,
                    }}
                  >

                    <span className="menu-icon">
                      {event.icon}
                    </span>

                    <span className="menu-event-name">
                      {event.title}
                    </span>

                  </button>
                )
              )}

            </div>

            <div className="sidebar-bottom">

              <span>
                🌱
              </span>

              <p>
                Participate in
                environmental activities
                and help protect our
                planet.
              </p>

            </div>

          </aside>

          {/* ==================================================
              MAIN CONTENT
          ================================================== */}

          <main className="event-main">

            {/* ==================================================
                HERO
            ================================================== */}

            <section
              className="event-hero-image"
              style={{
                "--event-color":
                  activeEvent.color,

                backgroundImage: `
                  linear-gradient(
                    rgba(0, 0, 0, 0.55),
                    rgba(0, 0, 0, 0.55)
                  ),
                  url("${activeEvent.gallery[0]}")
                `,
              }}
            >

              <div className="hero-image-content">

                <div className="event-hero-icon">
                  {activeEvent.icon}
                </div>

                <span>
                  ENVIRONMENTAL EVENT
                </span>

                <h1>
                  {activeEvent.title}
                </h1>

                <p>
                  {activeEvent.tagline}
                </p>

                <div className="hero-date">
                  📅 {activeEvent.date}
                </div>

              </div>

            </section>

            {/* ==================================================
                EVENT INFORMATION
            ================================================== */}

            <section className="event-information">

              <div className="section-heading">

                <span>
                  ABOUT THIS EVENT
                </span>

                <h2>
                  Understanding{" "}
                  {activeEvent.title}
                </h2>

                <p>
                  Learn about the history,
                  purpose and importance
                  of this environmental
                  event.
                </p>

              </div>

              <div className="details-grid">

                <div className="info-card">

                  <div className="info-card-icon">
                    📖
                  </div>

                  <div>

                    <small>
                      HISTORY
                    </small>

                    <h3>
                      Event History
                    </h3>

                    <p>
                      {activeEvent.history}
                    </p>

                  </div>

                </div>

                <div className="info-card">

                  <div className="info-card-icon">
                    🎯
                  </div>

                  <div>

                    <small>
                      PURPOSE
                    </small>

                    <h3>
                      Why Is It Celebrated?
                    </h3>

                    <p>
                      {activeEvent.purpose}
                    </p>

                  </div>

                </div>

                <div className="info-card">

                  <div className="info-card-icon">
                    ⭐
                  </div>

                  <div>

                    <small>
                      IMPORTANCE
                    </small>

                    <h3>
                      Why Is It Important?
                    </h3>

                    <p>
                      {activeEvent.importance}
                    </p>

                  </div>

                </div>

              </div>

            </section>

            {/* ==================================================
                INTERNATIONAL + PAKISTAN
            ================================================== */}

            <section className="level-section">

              <div className="level-card international-card">

                <div className="level-icon">
                  🌎
                </div>

                <div>

                  <span>
                    INTERNATIONAL LEVEL
                  </span>

                  <h2>
                    Global Activities
                  </h2>

                  <p>
                    {activeEvent.internationalInfo}
                  </p>

                </div>

              </div>

              <div className="level-card pakistan-card">

                <div className="level-icon">
                  🇵🇰
                </div>

                <div>

                  <span>
                    NATIONAL LEVEL
                  </span>

                  <h2>
                    Pakistan Initiatives
                  </h2>

                  <p>
                    {activeEvent.pakistanInfo}
                  </p>

                </div>

              </div>

            </section>

            {/* ==================================================
                LOCATIONS
            ================================================== */}

            <section className="locations-section">

              <div className="section-heading">

                <span>
                  PAKISTAN
                </span>

                <h2>
                  Where Activities Take Place
                </h2>

                <p>
                  Environmental activities
                  are organized in different
                  areas of Pakistan.
                </p>

              </div>

              <div className="location-grid">

                {activeEvent.pakistanPlaces.map(
                  (place, index) => (
                    <div
                      className="location-card"
                      key={index}
                    >

                      <span>
                        📍
                      </span>

                      <strong>
                        {place}
                      </strong>

                    </div>
                  )
                )}

              </div>

            </section>

            {/* ==================================================
                NATIONAL ACTIVITIES
            ================================================== */}

            <section className="pakistan-activities">

              <div className="section-heading">

                <span>
                  NATIONAL ACTIVITIES
                </span>

                <h2>
                  What Happens in Pakistan?
                </h2>

              </div>

              <div className="pakistan-activity-list">

                {activeEvent.pakistanActivities.map(
                  (activity, index) => (
                    <div
                      className="pakistan-activity"
                      key={index}
                    >

                      <span>
                        ✓
                      </span>

                      <p>
                        {activity}
                      </p>

                    </div>
                  )
                )}

              </div>

            </section>

            {/* ==================================================
                RESULTS
            ================================================== */}

            <section className="results-section">

              <div className="section-heading">

                <span>
                  KEY FACTS
                </span>

                <h2>
                  Important Facts
                </h2>

              </div>

              <div className="results-grid">

                {activeEvent.results.map(
                  (result, index) => (
                    <div
                      className="result-card"
                      key={index}
                      style={{
                        "--event-color":
                          activeEvent.color,
                      }}
                    >

                      <div className="result-icon">
                        {result.icon}
                      </div>

                      <strong>
                        {result.number}
                      </strong>

                      <span>
                        {result.label}
                      </span>

                    </div>
                  )
                )}

              </div>

            </section>

            {/* ==================================================
                GALLERY
            ================================================== */}

            <section className="gallery-section">

              <div className="section-heading">

                <span>
                  EVENT GALLERY
                </span>

                <h2>
                  Environmental Moments
                </h2>

              </div>

              <div className="gallery-grid">

                {activeEvent.gallery.map(
                  (image, index) => (
                    <div
                      className="gallery-item"
                      key={index}
                    >

                      <img
                        src={image}
                        alt={`${activeEvent.title} ${
                          index + 1
                        }`}
                      />

                      <div className="gallery-overlay">

                        <span>
                          📸
                        </span>

                        <p>
                          {activeEvent.title}
                        </p>

                      </div>

                    </div>
                  )
                )}

              </div>

            </section>

            {/* ==================================================
                PUBLISHED COMMUNITY ACTIVITIES
            ================================================== */}

            <section className="published-section">

              <div className="section-heading">

                <span>
                  ECO VIBE COMMUNITY
                </span>

                <h2>
                  Activities Performed by Users
                </h2>

                <p>
                  These activities were
                  submitted by our users
                  and approved by the
                  EcoVibe administrator.
                </p>

              </div>

              {publishedLoading ? (

                <div className="published-loading">

                  <div className="small-loader"></div>

                  <p>
                    Loading community
                    activities...
                  </p>

                </div>

              ) : currentPublishedActivities.length >
                0 ? (

                <div className="published-grid">

                  {currentPublishedActivities.map(
                    (submission, index) => {

                      const proofUrl =
                        getProofUrl(
                          submission.proof
                        );

                      const activityTitle =
                        submission.activityTitle ||
                        submission.activity?.title ||
                        submission.activity?.name ||
                        "Environmental Activity";

                      const activityDescription =
                        submission.description ||
                        submission.activity?.description ||
                        "EcoVibe community activity.";

                      const userName =
                        submission.user?.name ||
                        submission.userName ||
                        "EcoVibe Volunteer";

                      return (
                        <article
                          className="published-card"
                          key={
                            submission._id ||
                            index
                          }
                        >

                          <div className="published-media">

                            {proofUrl ? (

                              isVideoFile(
                                proofUrl
                              ) ? (

                                <video
                                  src={proofUrl}
                                  controls
                                  preload="metadata"
                                />

                              ) : (

                                <img
                                  src={proofUrl}
                                  alt={
                                    activityTitle
                                  }
                                  onError={(e) => {
                                    e.currentTarget.style.display =
                                      "none";
                                  }}
                                />

                              )

                            ) : (

                              <div className="no-proof">
                                🌱
                              </div>

                            )}

                            <span className="approved-badge">
                              ✓ APPROVED
                            </span>

                          </div>

                          <div className="published-content">

                            <div className="published-top">

                              <div className="community-icon">
                                🌿
                              </div>

                              <div>

                                <span>
                                  COMMUNITY MEMBER
                                </span>

                                <h3>
                                  {userName}
                                </h3>

                              </div>

                            </div>

                            <h4>
                              {activityTitle}
                            </h4>

                            <p>
                              {activityDescription}
                            </p>

                            <div className="published-footer">

                              <span>
                                🌍
                              </span>

                              <span>
                                EcoVibe
                                Environmental
                                Initiative
                              </span>

                            </div>

                          </div>

                        </article>
                      );
                    }
                  )}

                </div>

              ) : (

                <div className="no-published">

                  <div>
                    🌱
                  </div>

                  <h3>
                    No Published Activities Yet
                  </h3>

                  <p>
                    Once the admin approves
                    user activities, they
                    will appear here.
                  </p>

                </div>

              )}

            </section>

            {/* ==================================================
                PARTICIPATE
            ================================================== */}

            <section
              className="user-activities-section"
              style={{
                "--event-color":
                  activeEvent.color,
              }}
            >

              <div className="section-heading">

                <span>
                  PARTICIPATE
                </span>

                <h2>
                  Activities You Can Perform
                </h2>

                <p>
                  Choose an activity and
                  contribute to environmental
                  protection.
                </p>

              </div>

              <div className="activities-grid">

                {activeEvent.activities.map(
                  (activity, index) => {

                    const isSelected =
                      selectedActivity?.id ===
                      activity.id;

                    return (
                      <div
                        className={
                          isSelected
                            ? "activity-card selected"
                            : "activity-card"
                        }
                        key={activity.id}
                      >

                        <div className="activity-top">

                          <div
                            className="activity-icon"
                            style={{
                              backgroundColor:
                                `${activeEvent.color}18`,
                            }}
                          >
                            {activity.icon}
                          </div>

                          <span className="activity-number">
                            {String(
                              index + 1
                            ).padStart(2, "0")}
                          </span>

                        </div>

                        <h3>
                          {activity.title}
                        </h3>

                        <p>
                          {activity.description}
                        </p>

                        <button
                          type="button"
                          className="join-btn"
                          style={{
                            backgroundColor:
                              activeEvent.color,
                          }}
                          onClick={() =>
                            handleJoinActivity(
                              activity
                            )
                          }
                        >

                          {isSelected
                            ? "SELECTED ✓"
                            : "JOIN ACTIVITY"}

                          <b>
                            →
                          </b>

                        </button>

                      </div>
                    );
                  }
                )}

              </div>

            </section>

            {/* ==================================================
                PARTICIPATION FORM
            ================================================== */}

            <section
              id="participation-section"
              className="participation-section"
              style={{
                "--event-color":
                  activeEvent.color,
              }}
            >

              <div className="participation-header">

                <div>

                  <span>
                    USER PARTICIPATION
                  </span>

                  <h2>
                    Make Your Contribution
                  </h2>

                  <p>
                    Complete an activity,
                    upload your proof and
                    submit it for admin
                    approval.
                  </p>

                </div>

                <div className="participation-icon">
                  {activeEvent.icon}
                </div>

              </div>

              {selectedActivity ? (

                <div className="selected-activity">

                  <span className="selected-icon">
                    {selectedActivity.icon}
                  </span>

                  <div>

                    <small>
                      SELECTED ACTIVITY
                    </small>

                    <h3>
                      {selectedActivity.title}
                    </h3>

                    <p>
                      {selectedActivity.description}
                    </p>

                  </div>

                </div>

              ) : (

                <div className="select-activity-message">

                  <span>
                    👆
                  </span>

                  <div>

                    <strong>
                      Select an Activity First
                    </strong>

                    <p>
                      Click "JOIN ACTIVITY"
                      above to select the
                      activity you want to
                      perform.
                    </p>

                  </div>

                </div>

              )}

              <div className="upload-section">

                <div className="upload-box">

                  <label
                    htmlFor="event-upload"
                    className="upload-label"
                  >

                    <div className="upload-icon">
                      📁
                    </div>

                    <strong>
                      {selectedFile
                        ? selectedFile.name
                        : "Upload Photo or Video"}
                    </strong>

                    <span>
                      JPG, PNG, WEBP,
                      MP4 supported
                      (Max 20MB)
                    </span>

                    <span className="choose-file">
                      Choose File
                    </span>

                  </label>

                  <input
                    id="event-upload"
                    type="file"
                    accept="image/jpeg,image/jpg,image/png,image/webp,video/mp4,video/webm,video/quicktime"
                    onChange={
                      handleFileChange
                    }
                    disabled={
                      !selectedActivity ||
                      submitting
                    }
                    hidden
                  />

                </div>

                <label className="description-label">
                  Activity Description
                </label>

                <textarea
                  className="activity-description"
                  value={description}
                  onChange={(e) =>
                    setDescription(
                      e.target.value
                    )
                  }
                  placeholder={
                    selectedActivity
                      ? `Tell us how you performed "${selectedActivity.title}"...`
                      : "Select an activity first..."
                  }
                  disabled={
                    !selectedActivity ||
                    submitting
                  }
                />

                <button
                  type="button"
                  className="submit-btn"
                  style={{
                    backgroundColor:
                      activeEvent.color,
                  }}
                  onClick={
                    handleSubmit
                  }
                  disabled={
                    submitting ||
                    !selectedActivity
                  }
                >

                  {submitting ? (

                    <>
                      <span className="button-loader"></span>
                      SUBMITTING...
                    </>

                  ) : (

                    <>
                      <span>
                        📤
                      </span>

                      SUBMIT FOR APPROVAL
                    </>

                  )}

                </button>

                <div className="approval-note">

                  <span>
                    ℹ️
                  </span>

                  <div>

                    <strong>
                      Admin Approval Required
                    </strong>

                    <p>
                      Your contribution
                      will be reviewed by
                      an administrator.
                      Once approved, it
                      will appear in the
                      EcoVibe community
                      activities.
                    </p>

                  </div>

                </div>

              </div>

            </section>

          </main>

        </div>

      </div>

   
  );

};
export default EventPage;

